// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"PlayableVideo_thumbnail__mDtVa","playButton":"PlayableVideo_playButton__d0sFd"};